var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"form-control keywords",attrs:{"type":"text","name":"keywords","autocomplete":"off","placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"keydown":function($event){return _vm.$emit('keydown')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }